<script setup lang="ts">
import { Moon, Sun } from 'lucide-vue-next'
import UiIconButton from '@/components/ui/UiIconButton.vue'
import { useTheme } from '@/lib/theme'

/** One button between light and dark: the phone's bar, the meeting's pages. */
withDefaults(defineProps<{ tone?: 'plain' | 'stage'; size?: 'sm' | 'md' }>(), {
  tone: 'plain',
  size: 'sm',
})
const { dark, set } = useTheme()
</script>

<template>
  <UiIconButton
    :tone="tone"
    :size="size"
    :label="dark ? 'Switch to light' : 'Switch to dark'"
    @click="set(dark ? 'light' : 'dark')"
  >
    <Sun v-if="dark" class="size-5" :stroke-width="1.75" />
    <Moon v-else class="size-5" :stroke-width="1.75" />
  </UiIconButton>
</template>
